import React from 'react';
import ReactDOM from 'react-dom';
import PropTypes from 'prop-types';
import { Form } from 'react-final-form';
import arrayMutators from 'final-form-arrays';
import FormFieldsGenerator from '../FormFieldsGenerator';
import useControlledVocab from '../../hooks/useDataQueries';

const propTypes = {
  formValues: PropTypes.arrayOf(PropTypes.object),
  fieldArrayName: PropTypes.string,
};

function FormPreView({ formValues, fieldArrayName }) {
  const onHandleSubmit = (values) => {
    console.log(values);
  };

  const { data, pending } = useControlledVocab();
  // const FormElement = (
  //   <Form
  //     onSubmit={onHandleSubmit}
  //     mutators={{
  //       ...arrayMutators,
  //     }}
  //     render={(renderProps) => (
  //       <form id="instance-form-generator" onSubmit={renderProps.handleSubmit}>
  //         <FormFieldsGenerator
  //           key={`${fieldArrayName}-form-preview`}
  //           formValues={formValues}
  //         />
  //         <hr />
  //         <pre>{JSON.stringify(renderProps.values, 0, 2)}</pre>
  //       </form>
  //     )}
  //   />
  // );

  // const container = document.getElementById('ModuleContainer');
  // return ReactDOM.createPortal(FormElement, container);

  return (
    <Form
      onSubmit={onHandleSubmit}
      mutators={{
        ...arrayMutators,
      }}
      render={(renderProps) => (
        <form id="instance-form-generator" onSubmit={renderProps.handleSubmit}>
          <FormFieldsGenerator
            key={`${fieldArrayName}-form-preview`}
            formValues={formValues}
            controlledVocab={data}
          />
          <hr />
          <pre>{JSON.stringify(renderProps.values, 0, 2)}</pre>
        </form>
      )}
    />
  );
}

FormPreView.propTypes = propTypes;

export default FormPreView;
